import React, {FC, useState} from 'react'
import {Field, ErrorMessage, useField} from 'formik'
import {useIntl} from 'react-intl'
import {AnimaDireita2} from '../../../../../../../../_metronic/assets/animation/styles'
import {colourStyles} from '../../../addConditioning/styles/styles'
import CreatableSelect from 'react-select/creatable'

const Step2: FC = () => {
  const intl = useIntl()

  //constantes que recebem os valores do formulário
  const [annuity, ,] = useField('annuity')
  const [fieldStartdate, ,] = useField('start_date')
  const [fieldLimitdate, ,] = useField('limit_date')
  const [fieldStatus, ,] = useField('status')
  const [fielCharacter, ,] = useField('character')
  const [fieldConclusiondate, ,] = useField('conclusion_date')

  const [fieldAlertDays, , helperAlertDays] = useField('alert_days')
  // const [selectedAlertDays, setSelectedAlertDays] = useState<any[]>(
  //   fieldAlertDays.value.map((e: any) => {
  //     return {value: e.alert_day, label: `${e.alert_day}`}
  //   })
  // )

  const [selectedAlertDays, setSelectedAlertDays] = useState<any[]>(fieldAlertDays.value)

  const handleInputChangeAlertDays = (event: any) => {
    var inputValue = []
    if (event) {
      for (var i = 0; i < event.length; i++) {
        inputValue.push(parseInt(event[i].value))
      }
    }
    setSelectedAlertDays(event)
    helperAlertDays.setValue(inputValue)
    return {inputValue}
  }

  return (
    <div className='w-100'>
      <AnimaDireita2>
        <div className='pb-10 pb-lg-12'>
          <h2 className='fw-bolder text-dark'>{intl.formatMessage({id: 'CONDITIONINGS.STEP2'})}</h2>

          <div className='text-gray-400 fw-bold '>
            {intl.formatMessage({id: 'CONDITIONINGS.STEP2SUB'})}
          </div>
        </div>

        <div className='card-body  p-0 '>
          {/* inicio da primeira linha */}
          <div className='row'>
            {/* input de data de início */}
            <div className='col-lg-6'>
              <label className='form-label fw-bold'>
                {intl.formatMessage({id: 'COMMON.START_DATE'})}
              </label>
              <div className='d-flex align-items-center position-relative my-1'>
                <input
                  type='date'
                  className='form-control form-control-solid  ps-6'
                  {...fieldStartdate}
                />
              </div>
            </div>

            {/* input de data limite */}
            <div className='col-lg-6'>
              <label className='form-label fw-bold'>
                {intl.formatMessage({id: 'COMMON.LIMIT_DATE'})}
              </label>
              <div className='d-flex align-items-center position-relative my-1'>
                <input
                  type='date'
                  className='form-control form-control-solid  ps-6'
                  {...fieldLimitdate}
                />
              </div>
            </div>
          </div>
          {/* inicio da segunda linha */}
          <div className='row mt-3'>
            {/* input de status */}
            <div className='col-lg-6'>
              <label className='form-label fw-bold'>
                {intl.formatMessage({id: 'COMMON.STATUS'})}
              </label>
              <div className='d-flex align-items-center position-relative my-1'>
                {fielCharacter.value === 'imposing' && (
                  <select
                    className='form-select form-select-solid ps-6'
                    data-kt-select2='true'
                    {...fieldStatus}
                  >
                    <option value='not_started'>
                      {intl.formatMessage({id: 'COMMON.NOT_STARTED'})}
                    </option>
                    <option value='in_progress'>
                      {intl.formatMessage({id: 'COMMON.IN_PROGRESS'})}
                    </option>
                    <option value='done'>
                      {intl.formatMessage({id: 'CONDITIONINGS.STATUS_3'})}
                    </option>
                  </select>
                )}

                {fielCharacter.value === 'informative' && (
                  <select
                    className='form-select form-select-solid ps-6'
                    data-kt-select2='true'
                    defaultValue={''}
                    disabled={true}
                    {...fieldStatus}
                  >
                    <option value=''>Sem status - apenas para caráter informativo</option>
                  </select>
                )}
              </div>
            </div>

            {/* input de data de conclusão */}
            <div className='col-lg-6'>
              <label className='form-label fw-bold'>
                {intl.formatMessage({id: 'COMMON.CONCLUSION_DATE'})}
              </label>
              <div className='d-flex align-items-center position-relative my-1'>
                <input
                  type='date'
                  className='form-control form-control-solid  ps-6'
                  // disabled={true}
                  {...fieldConclusiondate}
                />
              </div>
            </div>
          </div>
          {/* fim da segunda linha */}

          {/* inicio da terceira linha */}
          <div className='row mt-3'>
            {/* input de carater */}
            <div className='col-lg-6'>
              <label className='form-label fw-bold'>
                {intl.formatMessage({id: 'CONDITIONINGS.CHARACTER'})}
              </label>
              <div className='d-flex align-items-center position-relative my-1'>
                <select
                  className='form-select form-select-solid ps-6'
                  data-kt-select2='true'
                  {...fielCharacter}
                >
                  <option value='imposing'>
                    {intl.formatMessage({id: 'CONDITIONINGS.CHARACTER_2'})}
                  </option>
                  <option value='informative'>
                    {intl.formatMessage({id: 'CONDITIONINGS.CHARACTER_1'})}
                  </option>
                </select>
              </div>
            </div>

            {/* input de custo */}
            <div className='col-lg-6'>
              <label className='form-label fw-bold'>
                {intl.formatMessage({id: 'CONDITIONINGS.COST'})}
              </label>
              <div className='d-flex align-items-center position-relative my-1'>
                <Field
                  name='conditioning_cost'
                  className='form-control form-control-lg form-control-solid'
                  placeholder={intl.formatMessage({id: 'CONDITIONINGS.COST'})}
                  mask='currency'
                />
                <div className='text-danger mt-2'>
                  <ErrorMessage name='conditioning_cost' />
                </div>
              </div>
            </div>
          </div>
          {/* fim da terceira linha */}
          {/* fim da terceira linha */}
          <div className='row mt-3'>
            <div className='col-lg-6'>
              <label className='form-label fw-bold'>Aviso de Renovação</label>

              <div className='d-flex position-relative my-1'>
                <CreatableSelect
                  className='form-control form-control-lg form-control-solid p-1 pl-1'
                  styles={colourStyles}
                  isMulti
                  placeholder='Quant. de dias'
                  {...fieldAlertDays}
                  value={selectedAlertDays}
                  onChange={handleInputChangeAlertDays}
                />
              </div>
            </div>

            <div className='col-lg-6'>
              <label className='form-label fw-bold required'>
                {intl.formatMessage({id: 'CONDITIONINGS.ANNUITY'})}
              </label>
              <div className='form-check form-switch form-check-custom form-check-solid fw-bold me-10'>
                <label className='form-check-label'> Não &nbsp;</label>

                <input
                  className='form-check-input h-20px w-30px'
                  type='checkbox'
                  checked={annuity.value === true ? true : false}
                  {...annuity}
                />
                <label className='form-check-label'>Sim </label>
              </div>
            </div>
          </div>
        </div>
      </AnimaDireita2>
    </div>
  )
}

export {Step2}
